import 'css-chunksrc/client/common/projectSection/project/portfolioList/styles.scss';export default {
  "tagList": "_tagList_kj3fq_1",
  "list": "_list_kj3fq_8",
  "buttonWrapper": "_buttonWrapper_kj3fq_17",
  "tags": "_tags_kj3fq_23",
  "hiddenTagsNbr": "_hiddenTagsNbr_kj3fq_31",
  "form": "_form_kj3fq_46",
  "icon": "_icon_kj3fq_54"
};